module.exports = __webpack_public_path__ + "static/img/SID-DRAPER.90cee0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SID-DRAPER.jpg
// module id = +Plu
// module chunks = 0